import Title from "./servicebusiness/title";
import Table from "./servicebusiness/table";

const ServiceBusiness = () => {
  return (
    <div className="flex flex-col">
      <Title />
      <Table />
    </div>
  );
};

export default ServiceBusiness;
